import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Music } from 'lucide-react';
import './App.css';

// Components
import Home from './components/Home';
import Features from './components/Features';
import Pricing from './components/Pricing';
import Customers from './components/Customers';

function App() {
  const [language, setLanguage] = useState('en');

  const translations = {
    en: {
      home: 'Home',
      features: 'Features',
      pricing: 'Pricing',
      customers: 'Customers'
    },
    es: {
      home: 'Inicio',
      features: 'Características',
      pricing: 'Precios',
      customers: 'Clientes'
    },
    sv: {
      home: 'Hem',
      features: 'Funktioner',
      pricing: 'Priser',
      customers: 'Kunder'
    }
  };

  const t = translations[language];

  return (
    <Router>
      <div className="App">
        <nav className="navbar">
          <div className="nav-brand">
            <Music className="nav-icon" />
            <span>Choir Web</span>
          </div>
          <div className="nav-links">
            <Link to="/">{t.home}</Link>
            <Link to="/features">{t.features}</Link>
            <Link to="/pricing">{t.pricing}</Link>
            <Link to="/customers">{t.customers}</Link>
            <select value={language} onChange={(e) => setLanguage(e.target.value)} className="lang-select">
              <option value="en">EN</option>
              <option value="es">ES</option>
              <option value="sv">SV</option>
            </select>
          </div>
        </nav>

        <Routes>
          <Route path="/" element={<Home language={language} />} />
          <Route path="/features" element={<Features language={language} />} />
          <Route path="/pricing" element={<Pricing language={language} />} />
          <Route path="/customers" element={<Customers language={language} />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
